import React from 'react'
import marked from 'marked'

import Row from '../../Shared/Row'
import Column from '../../Shared/Column'

const QuotesWithImages = (props) => (
    <Row className="block-quotes-with-images" id={ props.id }>
        <Column width="8" offsetL="4" tablet="12">
            {
                props.items &&
                props.items.map( (i, index) => (
                    <div key={ `${i.id}-${index}` } className="item">
                        <div className="logo">
                            <img src={ i.collegeLogo.file.url } alt=""/>
                        </div>
                        <div className="quote">
                            <h3>{ i.credit }</h3>
                            <div dangerouslySetInnerHTML={{ __html: marked(i.quote.internal.content) }} />
                        </div>
                    </div>
                ))
            }
        </Column>
    </Row>
)

export default QuotesWithImages



// WEBPACK FOOTER //
// ./src/components/WhatAboutCollege/QuotesWithImages/index.js